import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetQuestionSelectableTagsList = createAsyncThunk(
  "DropDownsManager/GetQuestionSelectableTagsList",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetQuestionSelectableTagsList",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const QuestionSelectableTagsList = createSlice({
  name: "QuestionSelectableTagsList",
  initialState: {
    QuestionSelectableTagsList: [],
    loadingQuestionSelectableTagsList: false,
    errorQuestionSelectableTagsList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetQuestionSelectableTagsList.pending, (state, action) => {
        state.loadingQuestionSelectableTagsList = true;
        state.QuestionSelectableTagsList = action.payload;
        state.errorQuestionSelectableTagsList = null;
      })
      .addCase(GetQuestionSelectableTagsList.fulfilled, (state, action) => {
        state.loadingQuestionSelectableTagsList = false;
        state.QuestionSelectableTagsList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetQuestionSelectableTagsList.rejected, (state, action) => {
        state.loadingQuestionSelectableTagsList = false;
        state.errorQuestionSelectableTagsList = action.payload;
      });
  },
});

export default QuestionSelectableTagsList.reducer;
